import api from "../../../api/api";

/* ===============================
   GET – list by company
=============================== */
export const getTimeLagList = (companyId: number) => {
  return api.get(`/company/v1/time-lag/?company=${companyId}`);
};

/* ===============================
   CREATE – bulk create
=============================== */
export const createTimeLagBulk = (data: any[]) => {
  return api.post("/company/v1/time-lag/", data);
};

/* ===============================
   UPDATE – bulk update
=============================== */
export const updateTimeLagBulk = (data: any[]) => {
  return api.post("/company/v1/time-lag/bulk-update/", data);
};
